import { useEffect, useState } from 'react';
import { loadOneSignal } from '../../oneSignal';
import './cookieConsentBanner.css'; // your optional styles

const CookieConsentBanner = ({ onAccept }) => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('userConsent');
    if (consent === 'accepted') {
      loadOneSignal(); // auto-load OneSignal if already accepted
    } else if (!consent) {
      setShowBanner(true); // show banner only if no consent yet
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('userConsent', 'accepted');
    loadOneSignal();
    setShowBanner(false);
    if (typeof onAccept === 'function') {
      onAccept(); // 🔥 notify parent like Home to update state
    }
  };

  const handleReject = () => {
    localStorage.setItem('userConsent', 'rejected');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <span>
        We use cookies for push notifications and maps. Read our{' '}
        <a href="/privacy" className="underline">Privacy Policy</a>.
      </span>
      <div className="ml-4 space-x-2">
        <button onClick={handleReject} className="bg-gray-700 px-3 py-1 rounded">Decline</button>
        <button onClick={handleAccept} className="bg-green-600 px-3 py-1 rounded">Accept</button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
